module.exports = __webpack_public_path__ + "img/planning.e4d3f6e2.png";